export const worldToNdc = /*glsl*/ `
  vec3 worldToNdc (vec3 worldPos, mat4 projectionMatrix, mat4 viewMatrix, float cameraNear, float cameraFar) {
    vec4 clipSpacePos = projectionMatrix * (viewMatrix * vec4(worldPos, 1.0));
    vec3 ndcSpacePos = clipSpacePos.xyz / clipSpacePos.w;
    ndcSpacePos.z /= cameraFar - cameraNear;
    return ndcSpacePos;
  }
`

export const resizeUVContain = /*glsl*/ `
  vec2 resizeUVContain(vec2 uv, vec2 size, vec2 res) {
    float tAspect = size.x / size.y;
    float pAspect = res.x / res.y;
    
    vec2 scale = vec2(1.0, 1.0);
    vec2 offset = vec2(0.0, 0.0);
    
    if (tAspect > pAspect) {
        scale.y = pAspect / tAspect;
        offset.y = (1.0 - scale.y) / 2.0;
    } else {
        scale.x = tAspect / pAspect;
        offset.x = (1.0 - scale.x) / 2.0;
    }
    
    return (uv - offset) / scale;
  }
`

export const translateUV = /*glsl*/ `
  vec2 translateUV(vec2 uv, vec2 translate) {
    return uv - translate;
  }
`

export const scaleUV = /*glsl*/ `
  vec2 scaleUV(vec2 uv, vec2 scale, vec2 origin) {
    vec2 st = uv - origin;
    st /= scale;
    return st + origin;
  }

  vec2 scaleUV(vec2 uv, vec2 scale) {
    return scaleUV(uv, scale, vec2(0.5));
  }
`

export const getTranslateMatrix = /*glsl*/ `
  mat4 getTranslateMatrix(vec2 translate) {
    return mat4(vec4(1.0,0.0,0.0,0.0),
                vec4(0.0,1.0,0.0,0.0),
                vec4(0.0,0.0,1.0,0.0),
                vec4(translate.x, translate.y, 0.0,1.0));
  }
`

export const getScaleMatrix = /*glsl*/ `
  mat4 getScaleMatrix(vec2 scale) {
    return mat4(vec4(scale.x,0.0,0.0,0.0),
                vec4(0.0,scale.y,0.0,0.0),
                vec4(0.0,0.0,1.0,0.0),
                vec4(0.0,0.0,0.0,1.0));
  }

  mat4 getScaleMatrix(float scale) {
    return getScaleMatrix(vec2(scale));
  }
`

export const getScreenUv = /*glsl*/ `
  vec2 getScreenUv() {
    vec3 vWorldPos = (modelMatrix * instanceMatrix * vec4(position, 1.0)).xyz;
    vec3 ndcSpacePos = worldToNdc(vWorldPos.xyz, projectionMatrix, viewMatrix, uCameraNear, uCameraFar);
    vec2 screenUv = (ndcSpacePos.xy + 1.0) * 0.5;

    return screenUv;
  }
`

export default `
  ${worldToNdc}
  ${resizeUVContain}
  ${translateUV}
  ${scaleUV}
  ${getTranslateMatrix}
  ${getScaleMatrix}
  ${getScreenUv}
`
